'use client';
/**
 * This file is for all accessibility related utilities.
 */
import {KeyboardEventHandler, KeyboardEvent} from 'react';

export const KEYBOARD_SUBMIT_KEYS = ['Enter', ' '];

export function getOnKeyDownProp(cb: (e: KeyboardEvent) => void): KeyboardEventHandler {
	return (e) => {
		if (KEYBOARD_SUBMIT_KEYS.includes(e.key)) {
			e.preventDefault(); // Prevent space from scrolling.
			cb(e);
		}
	};
}
